import { render } from "./CaseManage.vue?vue&type=template&id=61766302&scoped=true"
import script from "./CaseManage.vue?vue&type=script&lang=js"
export * from "./CaseManage.vue?vue&type=script&lang=js"

import "./CaseManage.vue?vue&type=style&index=0&id=61766302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61766302"]])

export default __exports__